import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import Navbar from "../../layout/Navbar/Navbar";
import Footer from "../../layout/Footer/Footer";
import "./HeaderStyles.scss";
import "./YungstarStyles.scss";

import logoRuby from "../../../assets/Ruby.png";
import logoFlame from "../../../assets/Flame-Sharks.png";
import logoWtr from "../../../assets/WATERMEL0N.png";
import logoOxuji from "../../../assets/Oxuji-Esports.png";
import logoEndless from "../../../assets/Endless-Journey.png";
import logoSangal from "../../../assets/Sangal-Esports.png";
import logo33 from "../../../assets/33.png";
import logoBaks from "../../../assets/BAKS Esports.png";
import logoGun5 from "../../../assets/GUN5-Esports.png";
import logoDGRN from "../../../assets/DRGN-TEAM.png";
import logoQuazar from "../../../assets/QUAZAR.png";
import logoSchool from "../../../assets/newSCHOOL.png";
import logoK27 from "../../../assets/K27.png";
import logoSparta from "../../../assets/SPARTA-Esports.png";
import logoDonstu from "../../../assets/Donstu Esports.png";
import logoAurora from "../../../assets/Aurora.png";
import YungstarLogo from "../../../assets/logo-star.png";
import star from "../../../assets/star.png";
import { DynamicBlock } from "./dynamicBlock";

const teams = [
	{ id: 1, name: "RUBY", logo: logoRuby },
	{ id: 2, name: "Flame Sharks", logo: logoFlame },
	{ id: 3, name: "WATERMEL0N", logo: logoWtr },
	{ id: 4, name: "Oxuji Esports", logo: logoOxuji },
	{ id: 5, name: "Endless Journey", logo: logoEndless },
	{ id: 6, name: "Sangal Esports", logo: logoSangal },
	{ id: 7, name: "TPuDCATb TPu", logo: logo33 },
	{ id: 8, name: "BAKS Esports", logo: logoBaks },
	{ id: 9, name: "GUN5 Esports", logo: logoGun5 },
	{ id: 10, name: "DRGN TEAM", logo: logoDGRN },
	{ id: 11, name: "QUAZAR", logo: logoQuazar },
	{ id: 12, name: "newSCHOOL", logo: logoSchool },
	{ id: 13, name: "K27", logo: logoK27 },
	{ id: 14, name: "SPARTA Esports", logo: logoSparta },
	{ id: 15, name: "Donstu Esports", logo: logoDonstu },
	{ id: 16, name: "Aurora Young Blud", logo: logoAurora },
];

const Yungstar = () => {
	const { t } = useTranslation();

	useEffect(() => {
		document.title = `${t("yungstarPage.documentTitle")} | GLuck Esports`;
	}, [t]);

	const bracketColumns = useMemo(
		() => [
			{
				title: t("yungstarPage.quarterFinal"),
				matches: [
					{ team1: teams[0], team2: teams[1] },
					{ team1: teams[2], team2: teams[3] },
					{ team1: teams[4], team2: teams[5] },
					{ team1: teams[6], team2: teams[7] },
				],
			},
			{
				title: t("yungstarPage.semiFinal"),
				matches: [
					{ team1: teams[0], team2: teams[3] },
					{ team1: teams[4], team2: teams[7] },
				],
			},
			{
				title: t("yungstarPage.final"),
				matches: [{ team1: teams[0], team2: teams[7] }],
			},
		],
		[t],
	);

	return (
		<div className="yungstar-page">
			<Navbar isVisible={true} />
			<section className="yungstar-hero">
				<div className="yungstar-hero__inner">
					<DynamicBlock className="yungstar-hero__tagline" aria-hidden="true">
						<span>{t("yungstarPage.taglineLine1")}</span>
						<span>{t("yungstarPage.taglineLine2")}</span>
					</DynamicBlock>

					<img
						src={YungstarLogo}
						alt={t("yungstarPage.heroAlt")}
						className="yungstar-hero__img"
					/>
				</div>
				<div className="yungstar-hero__glow" aria-hidden="true" />
			</section>

			<section className="yungstar-about">
				<div className="yungstar-about__inner">
					<DynamicBlock direction="right" className="yungstar-about__visual">
						<img src={star} alt={t("yungstarPage.starAlt")} />
					</DynamicBlock>
					<DynamicBlock direction="left" className="yungstar-about__card">
						<h2>{t("yungstarPage.title")}</h2>
						<p className="yungstar-about__sub">{t("yungstarPage.subtitle")}</p>
						<p className="yungstar-about__desc">
							{t("yungstarPage.description")}
						</p>
						<ul className="yungstar-about__facts">
							<li>
								<a
									href="https://liquipedia.net/counterstrike/GLuck_Yungstar/2025"
									target="_blank"
									rel="noreferrer"
								>
									{t("yungstarPage.liquipedia")}
								</a>
							</li>
						</ul>
					</DynamicBlock>
				</div>
			</section>

			<section className="yungstar-info">
				<DynamicBlock className="yungstar-info__card">
					<p
						dangerouslySetInnerHTML={{
							__html: t("yungstarPage.infoHtml1"),
						}}
					/>
					<p
						dangerouslySetInnerHTML={{
							__html: t("yungstarPage.infoHtml2"),
						}}
					/>
				</DynamicBlock>
			</section>

			<section className="yungstar-teams">
				<div className="yungstar-teams__logos">
					{teams.map((team) => (
						<div key={`team-logo-${team.id}`} className="yungstar-teams__logo">
							<img
								src={team.logo}
								alt={t("yungstarPage.logoAlt", { name: team.name })}
								loading="lazy"
								style={{
									width: "100%",
									height: "100%",
									objectFit: "contain",
									display: "block",
								}}
							/>
						</div>
					))}
				</div>
				<h3 className="yungstar-section-title">
					{t("yungstarPage.participantsTitle")}
				</h3>

				<div className="yungstar-teams__grid">
					{teams.map((team) => (
						<div key={team.id} className="yungstar-team">
							<span className="yungstar-team__name">{team.name}</span>
						</div>
					))}
				</div>
			</section>

			<section className="yungstar-bracket">
				<h3 className="yungstar-section-title">
					{t("yungstarPage.bracketTitle")}
				</h3>
				<div className="yungstar-bracket__grid">
					{bracketColumns.map((column, colIndex) => (
						<div key={colIndex} className="bracket__col">
							<h4>{column.title}</h4>
							<DynamicBlock
								className="bracket__col__teams"
								delayMs={350 * colIndex}
								infinite={false}
							>
								{column.matches.map((match, matchIndex) => (
									<div key={matchIndex} className="match">
										<div className="team">
											{match.team1
												? match.team1.name
												: t("yungstarPage.teamTbd")}
										</div>
										<div className="team">
											{match.team2
												? match.team2.name
												: t("yungstarPage.teamTbd")}
										</div>
									</div>
								))}
							</DynamicBlock>
						</div>
					))}
				</div>
			</section>

			<Footer alwaysVisible={true} />
		</div>
	);
};

export default Yungstar;
